import React from 'react';
import { Slider } from '../../../ui/components/Slider';

interface QuickRateControlProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    step?: number;
}

const getRatingEmoji = (value: number): string => {
    if (value >= 9) return '🔥';
    if (value >= 7) return '😊';
    if (value >= 5) return '😐';
    if (value >= 3) return '😕';
    return '😞';
};

const getRatingColor = (value: number): string => {
    if (value >= 8) return 'text-emerald-600';
    if (value >= 5) return 'text-amber-600';
    return 'text-red-500';
};

export const QuickRateControl: React.FC<QuickRateControlProps> = ({
    value,
    onChange,
    min = 0,
    max = 10,
    step = 0.1,
}) => {
    const safeValue = typeof value === 'number' && !Number.isNaN(value) ? value : 5;
    const clampedValue = Math.max(min, Math.min(max, safeValue));
    // round to one decimal so floating-point drift doesn't render as "7.300000000000001"
    const display = Math.round(clampedValue * 10) / 10;

    return (
        <div className="space-y-4">
            <div className="flex flex-col items-center gap-1 py-2">
                <span className="text-3xl">{getRatingEmoji(display)}</span>
                <span className={`text-5xl font-bold tabular-nums ${getRatingColor(display)}`}>
                    {display.toFixed(1)}
                </span>
                <span className="text-xs text-muted-foreground">out of 10</span>
            </div>
            <Slider
                value={[clampedValue]}
                onValueChange={(values) => {
                    const next = values[0];
                    if (typeof next === 'number') {
                        onChange(Math.round(next * 10) / 10);
                    }
                }}
                min={min}
                max={max}
                step={step}
            />
            <div className="flex justify-between text-[11px] text-muted-foreground px-0.5">
                <span>awful</span>
                <span>perfect</span>
            </div>
        </div>
    );
};
